"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useLatest_1 = __importDefault(require("./useLatest"));
function useKeyPress(targetKey, handler, enabled = true) {
    // State for keeping track of whether key is pressed
    const [keyPressed, setKeyPressed] = (0, react_1.useState)(false);
    const handlerRef = (0, useLatest_1.default)(handler);
    // If pressed key is our target key then set to true
    const downHandler = (0, react_1.useCallback)((event) => {
        if (event.key === targetKey) {
            setKeyPressed(true);
            handlerRef.current && handlerRef.current(event);
        }
    }, [targetKey, setKeyPressed]);
    // If released key is our target key then set to false
    const upHandler = (0, react_1.useCallback)(() => {
        setKeyPressed(false);
    }, [setKeyPressed]);
    // Add event listeners
    (0, react_1.useEffect)(() => {
        if (enabled) {
            window.addEventListener("keydown", downHandler);
            window.addEventListener("keyup", upHandler);
        }
        else {
            window.removeEventListener("keydown", downHandler);
            window.removeEventListener("keyup", upHandler);
        }
        // Remove event listeners on cleanup
        return () => {
            window.removeEventListener("keydown", downHandler);
            window.removeEventListener("keyup", upHandler);
        };
    }, [enabled]);
    return keyPressed;
}
exports.default = useKeyPress;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlS2V5cHJlc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2hvb2tzL3VzZUtleXByZXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsaUNBQTBFO0FBQzFFLDREQUFvQztBQUlwQyxTQUF3QixXQUFXLENBQ2pDLFNBQVMsRUFDVCxPQUF5QixFQUN6QixPQUFPLEdBQUcsSUFBSTtJQUVkLG9EQUFvRDtJQUNwRCxNQUFNLENBQUMsVUFBVSxFQUFFLGFBQWEsQ0FBQyxHQUFHLElBQUEsZ0JBQVEsRUFBQyxLQUFLLENBQUMsQ0FBQztJQUNwRCxNQUFNLFVBQVUsR0FBRyxJQUFBLG1CQUFTLEVBQWtCLE9BQU8sQ0FBQyxDQUFDO0lBRXZELG9EQUFvRDtJQUNwRCxNQUFNLFdBQVcsR0FBRyxJQUFBLG1CQUFXLEVBQzdCLENBQUMsS0FBb0IsRUFBRSxFQUFFO1FBQ3ZCLElBQUksS0FBSyxDQUFDLEdBQUcsS0FBSyxTQUFTLEVBQUU7WUFDM0IsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ3BCLFVBQVUsQ0FBQyxPQUFPLElBQUksVUFBVSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQztTQUNqRDtJQUNILENBQUMsRUFDRCxDQUFDLFNBQVMsRUFBRSxhQUFhLENBQUMsQ0FDM0IsQ0FBQztJQUVGLHNEQUFzRDtJQUN0RCxNQUFNLFNBQVMsR0FBRyxJQUFBLG1CQUFXLEVBQUMsR0FBRyxFQUFFO1FBQ2pDLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUN2QixDQUFDLEVBQUUsQ0FBQyxhQUFhLENBQUMsQ0FBQyxDQUFDO0lBRXBCLHNCQUFzQjtJQUN0QixJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ2IsSUFBSSxPQUFPLEVBQUU7WUFDWCxNQUFNLENBQUMsZ0JBQWdCLENBQUMsU0FBUyxFQUFFLFdBQVcsQ0FBQyxDQUFDO1lBQ2hELE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxPQUFPLEVBQUUsU0FBUyxDQUFDLENBQUM7U0FDN0M7YUFBTTtZQUNMLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxTQUFTLEVBQUUsV0FBVyxDQUFDLENBQUM7WUFDbkQsTUFBTSxDQUFDLG1CQUFtQixDQUFDLE9BQU8sRUFBRSxTQUFTLENBQUMsQ0FBQztTQUNoRDtRQUNELG9DQUFvQztRQUNwQyxPQUFPLEdBQUcsRUFBRTtZQUNWLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxTQUFTLEVBQUUsV0FBVyxDQUFDLENBQUM7WUFDbkQsTUFBTSxDQUFDLG1CQUFtQixDQUFDLE9BQU8sRUFBRSxTQUFTLENBQUMsQ0FBQztRQUNqRCxDQUFDLENBQUM7SUFDSixDQUFDLEVBQUUsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0lBRWQsT0FBTyxVQUFVLENBQUM7QUFDcEIsQ0FBQztBQTFDRCw4QkEwQ0MifQ==